module.exports = require('./toPairsIn');



//////////////////
// WEBPACK FOOTER
// /srv/_versions/easypost-web/easypost-web-201703161753-430ad182f9-master/~/lodash/entriesIn.js
// module id = 1039
// module chunks = 1